import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { ICitiesGetAllParams, ICitiesResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICitiesResponse>>,
  IPathBaseParam,
  IPaginationParams & ICitiesGetAllParams
>("geo.cities");
const getApis = createGetApi<
  IApiResponse<ICitiesResponse>,
  IPathByIdParam,
  object
>("geo.cities");

export const cities = {
  ...getAllApis,
  ...getApis,
};
